// Pure queue transitions for the shell-level fresh-achievements toast.
// `FreshAchievementsContext` delegates here so vitest can lock FIFO +
// session dedupe without a React test harness.
import type { AdsActivityFreshAchievement } from "@/lib/adsAssistantClientEngagement";

export type FreshAchievement = AdsActivityFreshAchievement;

/** Append newly-unlocked rows; skips invalid ids, queue duplicates, and session-seen ids. */
export function publishToFreshAchievementsQueue(
  prev: FreshAchievement[],
  rows: FreshAchievement[],
  observedIds: Set<string>,
): FreshAchievement[] {
  if (rows.length === 0) return prev;

  const seen = new Set(prev.map((r) => r.id));
  const additions: FreshAchievement[] = [];
  for (const r of rows) {
    if (!r || typeof r.id !== "string") continue;
    if (observedIds.has(r.id)) continue;
    if (seen.has(r.id)) continue;
    observedIds.add(r.id);
    additions.push(r);
  }
  return additions.length > 0 ? [...prev, ...additions] : prev;
}

/** Remove one row from the visible queue (does not forget session-seen ids). */
export function dismissFromFreshAchievementsQueue(prev: FreshAchievement[], id: string): FreshAchievement[] {
  return prev.filter((r) => r.id !== id);
}
